import Vue from "vue";

export default {
    state: {
        isKiosk: false,
        showKioskSplashOnHome: true,
        hideSetupButton: false,
    },
    actions: {},
    mutations: {
        setIsKiosk(state, v) {
            return state.isKiosk = !!v;
        },
        setShowKioskSplashOnHome(state, v) {
            return state.showKioskSplashOnHome = !!v;
        },
        hideSetupButton(state, v) {
            Vue.ls.set('hideSetupButton', !!v);
            return state.hideSetupButton = !!v;
        },
    },
    getters: {
        isKiosk: (state) => {
            return state.isKiosk;
        },
        showKioskSplashOnHome: (state) => {
            return state.showKioskSplashOnHome;
        },
        hideSetupButton: (state) => {
            return state.hideSetupButton;
        },
    }
};
